import { createContext, useContext } from 'react';

export interface ToastInput {
  text: string;
  variant?: 'info' | 'destructive' | 'success' | 'default';
}

interface ImperativeToasts {
  publish(toast: ToastInput): void;
}

export const ToastsContext = createContext<ImperativeToasts>(null!);

export function useToast() {
  return useContext(ToastsContext);
}
